import {AfterViewInit, Component} from '@angular/core';
import {ComponentCleaner} from '../../../../component-cleaner';
import {CustomerGroupService} from '../../../customer-group/customer-group.service';
import {MatDialog} from '@angular/material/dialog';
import {PermissionWrapper} from '../../../../directives/if-permission.directive';
import {CustomerGroup, GatewayServer, GuacServer} from '../../../../models';
import {GuacServerDaoService} from '../guac-server-dao.service';
import {faCircle} from '@fortawesome/free-solid-svg-icons';
import {filter} from 'rxjs/operators';
import {CrudOperationWrapper} from '../../../../helpers/kluh';
import {GuacServerEditComponent} from '../guac-server-edit/guac-server-edit.component';
import {GatewayServerInUseComponent} from '../../../gateway-server/gateway-server-in-use/gateway-server-in-use.component';
import {GuacServerInUseComponent} from '../guac-server-in-use/guac-server-in-use.component';

@Component({
    selector: 'app-guac-server-list',
    templateUrl: './guac-server-list.component.html',
    styleUrls: ['./guac-server-list.component.scss']
})
export class GuacServerListComponent extends ComponentCleaner implements AfterViewInit {
    loading: boolean[] = [];

    protected readonly faCircle = faCircle;

    constructor(
        private customerGroupService: CustomerGroupService,
        private guacServerDaoService: GuacServerDaoService,
        private dialog: MatDialog,
        private dialogRef: MatDialog,
    ) {
        super();
        this.appCanCreateList = [
            {type: 'GuacServer', permission: 'CREATE', parentType: 'CustomerGroup', parent: this.customerGroupService.customerGroup},
        ];
    }

    appCanCreateList: PermissionWrapper[];
    guacServerList: GuacServer[] = [];
    customerGroup: CustomerGroup;

    ngAfterViewInit(): void {

        this.customerGroupService.get().subscribe(customerGroup => {
            if (customerGroup) {
                this.customerGroup = customerGroup;
                this.loadGuacServerListFromDao(customerGroup);
            }
        });
    }

    private loadGuacServerListFromDao(customerGroup: CustomerGroup): void {
        this.guacServerList = [];
        if (customerGroup.id) {
            this.guacServerDaoService.findAllBy(customerGroup.id).subscribe(guacServerList => {
                this.guacServerList = guacServerList;
            });
        }
    }


    guacServerInUseModal(guacServer: GuacServer): void {
        const dialogRef = this.dialog.open(GuacServerInUseComponent, {
            disableClose: true,
            panelClass: 'generic-edit-dialog-x-large',
            data: {
                guacServer: guacServer
            }
        });
        this.addSubscription(dialogRef.afterClosed().pipe(filter((x) => !!(x))).subscribe((_: CrudOperationWrapper) => {
            this.dialogRef.closeAll();
        }));
    }

    edit(guacServer: GuacServer): void {
        const dialogRef = this.dialog.open(GuacServerEditComponent, {
            disableClose: true,
            panelClass: 'generic-edit-dialog-x-large',
            data: {
                guacServer: guacServer,
                customerGroupId: this.customerGroup.id,
            }
        });
        this.addSubscription(dialogRef.afterClosed().pipe(filter((x) => !!(x))).subscribe((result: CrudOperationWrapper) => {
            if (result.data) {
                const index = this.guacServerList.findIndex(value => value.id === result.data.id);
                if (index > -1) {
                    if (result.operation !== 'DELETE') {
                        this.guacServerList[index] = result.data;
                    } else {
                        this.guacServerList.splice(index, 1);
                    }
                } else {
                    this.guacServerList.push(result.data);
                }
            }
        }));
    }
}
